import colors from './colors'

export default `0px 1px 10px ${colors.lightGrey}`
